import { createContext, useContext } from 'react';

import useAutoCallFeature from '@/app/mutations/Shared/useAutoCallFeature';

export interface Recording {
  isRecording: boolean;
  start(): void;
  stop(): void;
}

export const RecordingContext = createContext<Recording>(null!);

export function useRecording() {
  return useContext(RecordingContext);
}

export function useAutoRecording({ joined }: { joined: boolean }, isEnabled: boolean) {
  const recording = useRecording();
  useAutoCallFeature(
    { joined, isEnabled },
    { isActive: recording.isRecording, start: recording.start, stop: recording.stop },
  );
}
